import type { DashboardLayouts } from "@msuite/utils/types";
import { createContext, useContext } from "react";
import type { QueryKey } from "../query";

/** Interface */
interface IDashboardContext {
	layouts: DashboardLayouts;
}

interface IDashboardTileListContext {
	queryKey: QueryKey;
	refetch: () => Promise<void>;
}

/** Context */
export const DashboardContext = createContext<IDashboardContext>({} as IDashboardContext);
export const DashboardTileListContext = createContext<IDashboardTileListContext>(
	{} as IDashboardTileListContext,
);

/** Hooks */
export function useDashboardContext(): IDashboardContext {
	return useContext(DashboardContext);
}

export function useDashboardTileListContext(): IDashboardTileListContext {
	return useContext(DashboardTileListContext);
}
